// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1565c0", // Deep blue
    },
    secondary: {
      main: "#f57c00", // Orange
    },
    background: {
      default: "#fafafa",
    },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
    button: { textTransform: "none" },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
